import { withErrorBoundary, Formatter } from 'shared'
import { SmartButtonStub } from 'ui/smart-buttons'
import { LogoImage } from 'customizations'
import { User } from 'api'
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import 'react-phone-number-input/style.css';
import Input from 'react-phone-number-input/input';
import { useEffect, useState } from 'react'

const SignupPage = () => {
  const [state, setState] = useState({
    user: { email: '', phone: '', first_name: '', last_name: '', address: '', user_role_id: '', nonce: '' },
    settings: {}, card: {}
  });

  useEffect(() => {
    loadData();
    parseUTM();
    if (User.signedIn && User.regular) App.signOut({ redirectPath: '/app/signup' });
  }, []);

  const loadData = async () => {
    const settings = await Backend.get('/signup_settings');
    setState(prev => ({ ...prev, settings }));
    setupSquarePayment(settings);
  };

  const parseUTM = () => {
    const params = application.queryParams;
    if (params && params.has('utm_source')) {
      const utm_source = params.get('utm_source');
      setState(prev => ({
        ...prev,
        user: { ...prev.user, utm_source }
      }));
    }
  };

  const setupSquarePayment = async (settings) => {
    if (settings.require_payment) {
      const squarePayment = window.Square.payments(application.squareApplicationId, null);
      const card = await squarePayment.card();
      await card.attach('#card-container');
      setState(prev => ({ ...prev, card }));
    }
  };

  const inputChanged = (e) => {
    const { name, value } = e.target;
    setState(prev => ({
      ...prev,
      user: { ...prev.user, [name]: value },
      errors: null
    }));
  };

  const inputChangednew = (value) => {
    setState(prev => ({
      ...prev,
      user: { ...prev.user, phone: value },
      errors: null
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    const addressVal = document.getElementsByClassName("google-places-autocomplete__input")[0]?.value;
    const updatedUser = { ...state.user, address: addressVal };
    setState(prev => ({ ...prev, submitting: true, user: updatedUser }));

    if (state.settings.require_payment) {
      const result = await state.card.tokenize();
      if (result.status === 'OK') {
        updatedUser.nonce = result.token;
      }
    }

    try {
      await Backend.post('/users', { user: updatedUser });
      setState(prev => ({ ...prev, errors: null, success: true, submitting: false }));
    } catch (xhr) {
      if (xhr.status >= 400 && xhr.status <= 499) {
        setState(prev => ({
          ...prev,
          errors: xhr.responseJSON.errors,
          submitting: false
        }));
      }
    }
  };

  const renderSuccess = () => (
    <p className="alert alert-success text-center">
      {App.isBigSky
        ? "Thank you for registering! Please check your email for additional welcome information and credentials."
        : "Thank you for registering!  Please Sign In to activate your account."
      }
    </p>
  );

  const renderForm = () => {
    const settings = state.settings || {};

    return (
      <form className="signup--form" onSubmit={submit}>
        <p dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(settings.welcome_text) }}></p>
        {state.errors && state.errors.map((error, i) => (
          <p key={i} className="alert alert-danger alert-mini text-center">{error}</p>
        ))}

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--first-name">First Name</label>
              <input type="text" className="form-control" id="signup--first-name" name="first_name" value={state.user.first_name} onChange={inputChanged} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--last-name">Last Name</label>
              <input type="text" className="form-control" id="signup--last-name" name="last_name" value={state.user.last_name} onChange={inputChanged} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--email">Email Address</label>
              <input type="email" className="form-control" id="signup--email" name="email" value={state.user.email} onChange={inputChanged} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--phone">Phone Number</label>
              <Input
                placeholder="Enter phone number"
                type="tel"
                country="US"
                international
                withCountryCallingCode
                maxLength={15}
                className="form-control"
                id="signup--phone"
                name="phone"
                value={state.user.phone}
                onChange={inputChangednew}
              />
            </div>
          </div>
        </div>

        {!settings.hide_address && (
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="signup--address">
                  {App.isBigSky ? 'Zip Code' : 'Address'}
                </label>
                <GooglePlacesAutocomplete
                  apiKey={App.googleApiKey}
                  placeholder=""
                  onSelect={({ description }) => {
                    setState(prev => ({
                      ...prev,
                      user: { ...prev.user, address: description },
                      errors: null
                    }));
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="user_role_id">Select Your Account Type</label>
              <select className="form-control" name="user_role_id" value={state.user.user_role_id} onChange={inputChanged}>
                <option value="">Select any</option>
                {settings.user_roles && settings.user_roles.map((role) => (
                  <option value={role.id} key={role.id}>{role.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {settings.require_payment && (
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="signup--payment">Payment Details</label>
                <div id="card-container"></div>
              </div>
            </div>
          </div>
        )}

        <div className="form-actions text-center">
          <SmartButtonStub
            text="Sign Up"
            buttonType="submit"
            className="inverted primary"
            spinning={state.submitting}
          />
        </div>
      </form>
    );
  };

  const settings = state.settings || {};

  return (
    <div className="Login Signup">
      <div className="left d-none d-sm-block">
        <div className="left-overlay"></div>
        <p className="login-copyright">{application.assets.get('copyright')}</p>
      </div>
      <div className="right">
        <img src={LogoImage} className="logo-image mb-2" />
        <section className="form">
          <h3 className="mb-3 d-none">Sign Up</h3>
          {state.success ? renderSuccess() : renderForm()}
          {!App.isBigSky && (
            <p className="links text-center my-2">
              <Link to="/home?openSignIn=true" className="smart-button btn inverted primary">
                <span className="smart-button-text">Return to Sign In</span>
              </Link>
            </p>
          )}
          <p className="links text-center my-2">
            <a href="/u/account-deletion" className="smart-button btn inverted primary">
              <span className="smart-button-text">Request Account Deletion</span>
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default withErrorBoundary(SignupPage);
